import * as types from "../constants/actionConstants";
import TemplateApi from "../api/TemplateApi";
import * as system from "../constants/systemConstants";
import {msalInstance} from '../authProvider';
import {STORAGE_IS_SSO} from "../portal/constants/systemConstants";
import { validateTokenAuthorities, createUnauthorizedMessage } from "../utilities/jwtUtils";


export function getToken() {
    return localStorage.getItem(system.STORAGE_TOKEN) || sessionStorage.getItem(system.STORAGE_TOKEN);
}

export function fetchToken(userName, password, rememberMe = false) {
    return (dispatch) => {
        dispatch({type: types.TOKEN_GET, rememberMe, username: userName});
        if (rememberMe) {
            localStorage.setItem(system.STORAGE_USERNAME, userName);
        }
        else {
            localStorage.removeItem(system.STORAGE_USERNAME);
        }
        localStorage.setItem(STORAGE_IS_SSO,"false");        TemplateApi.getAuthorizationToken(userName, password, rememberMe).then((token) => {
            if (token[system.STORAGE_TOKEN]) {
                // Validate token authorities before setting token
                if (validateTokenAuthorities(token[system.STORAGE_TOKEN])) {
                    dispatch(setToken(token[system.STORAGE_TOKEN]));                } else {
                    console.log("Admin token rejected: No valid authorities found");
                    dispatch(rejectLogin(createUnauthorizedMessage(token[system.STORAGE_TOKEN])));
                }
            }
        });
    };
}


export function initializeAuthorization() {
    let login = {
        loggedIn: false,
        username: "",
    };   
    
    login.loggedIn = !!(localStorage.getItem(system.STORAGE_TOKEN) || 
                    sessionStorage.getItem(system.STORAGE_TOKEN));

    login.username = localStorage.getItem(system.STORAGE_USERNAME) || 
    sessionStorage.getItem(system.STORAGE_USERNAME) || 
    '';
   
    return {
        type: types.TOKEN_INITIALIZE,
        payload: login
    };
}

export function logout() {
    let m = clearToken("");
    let res = localStorage.getItem(STORAGE_IS_SSO) || 'false';
    if (res === 'true'){
    msalInstance.logoutRedirect().then(() => {
            return m;
        });
    }
    else{
        return m;
    }

}


export function setToken(token) {
    localStorage.setItem(system.STORAGE_TOKEN, token);

    return {
        type: types.TOKEN_SET
    };
}

export function clearToken(message) {
    localStorage.removeItem(system.STORAGE_TOKEN);

    return {
        type: types.TOKEN_CLEAR,
        message
    };
}

export function rejectLogin(message) {
    localStorage.removeItem(system.STORAGE_TOKEN);

    return {
        type: types.TOKEN_REJECT_LOGIN,
        message
    };
}


//TODO consider adding hooks to the local storage events to watch for logout?
